import React, { useState, useEffect } from 'react';
import { Route, Link, useHistory } from 'react-router-dom';
// styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
// toast
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// components
import Header from '../../components/header';
import Footer from '../../components/footer';
import BuyNow from '../../components/buyNowSection';
import Carousel from '../../components/carousel';
import Input from '../../components/input';
const Login = () => {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  toast.configure();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const physicalId = localStorage.getItem('physicalId');
    if (token && physicalId) {
      history.push('/dashboard');
      toast.success('User already logged!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    } else {
      localStorage.clear();
      history.location = '/';
    }
  }, []);

  const handleLogin = async () => {
    if (email !== '' && password !== '') {
      await fetch('api/v4/auth/login', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          authenticationDetails: {
            applicationId: 'SANDMANDOPPLER',
            email: email,
            password: password,
          },
          deviceDetails: {
            applicationVersion: '154',
            deviceId: '12345678',
            deviceModel: 'PIXEL',
            deviceType: 'PHONE',
            osType: 'ANDROID',
            osVersion: '9',
            timezone: {
              currentTimeInClientInMilliseconds: 0,
              offsetFromUTCInMilliseconds: 0,
              timeZoneId: 'UTC',
            },
          },
        }),
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.errorCode === 401) {
            toast.error('Incorrect email or pasword!', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            });
          } else if (result.accessToken) {
            localStorage.setItem('token', result.accessToken);
            history.push('/dashboard');
            toast.success('User logged in successfully', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error('Error! While connecting to server', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) =>
          toast.error('Error! While connecting to server', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          })
        );
    } else {
      toast.error('Please check the input fileds!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <div>
      <Header />
      <BuyNow />
      <Carousel />

      <section
        class='login-bg'
        style={{ backgroundImage: 'url(./images/login-bg.jpg)' }}
      >
        <div class='container container-sm'>
          <h2>LOG IN</h2>
          <Input
            placeHolder='Email*'
            type='text'
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            placeHolder='Password*'
            type='password'
            onChange={(e) => setPassword(e.target.value)}
          />
          <div class='text-right'>
            <a href='#' class='text-right underline'>
              Forgot Password
            </a>
          </div>
          <div class='text-center'>
            <button class='submit-btn' onClick={handleLogin}>
              LOG IN
            </button>
          </div>
          <p class='create-account text-center mb-2'>
            New to Doppler?{' '}
            <Route>
              <Link to='/signup'>Create an account</Link>
            </Route>
          </p>
          <p class='text-center'>Version 1.3.9</p>
        </div>
      </section>
    </div>
  );
};
export default Login;
